// extracted by mini-css-extract-plugin
var _1 = "container--zFI8e";
var _2 = "loading--KDYj6";
export { _1 as "container", _2 as "loading" }
